import React, { Dispatch, SetStateAction } from 'react';
import { H } from '../../../common/Layout';
import ProductionStatusNoteActions from './ProductionStatusNoteActions';
import ProductionStatusNoteTitle from './ProductionStatusNoteTitle';

export type ProductionStatusNoteHeaderProps = {
    toggleEditor: Dispatch<SetStateAction<boolean>>;
    currentNoteId: string;
    onStatusNoteDeleted?: (noteId: string, productionId: string) => void;
    productionId?: string;
    onNewStatusNoteClick?: ({ isCreateNewNote }: { isCreateNewNote: boolean }) => void;
};

export default function ProductionStatusNoteHeader({
    toggleEditor,
    currentNoteId,
    onStatusNoteDeleted,
    productionId,
    onNewStatusNoteClick
}: ProductionStatusNoteHeaderProps) {
    return (
        <H gap={0.5} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <ProductionStatusNoteTitle />

            <ProductionStatusNoteActions
                toggleEditor={toggleEditor}
                currentNoteId={currentNoteId}
                productionId={productionId}
                onStatusNoteDeleted={onStatusNoteDeleted}
                onNewStatusNoteClick={onNewStatusNoteClick}
            />
        </H>
    );
}
